import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  DeleteProposalGroupInput,
  DeleteProposalGroupMutation,
} from '@/gql/graphql';

const DELETE_PROPOSAL_GROUP_MUTATION = graphql(`
  mutation DeleteProposalGroup($input: DeleteProposalGroupInput!) {
    deleteProposalGroup(input: $input) {
      id
    }
  }
`);

const useDeleteProposalGroup = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    DeleteProposalGroupMutation,
    unknown,
    DeleteProposalGroupInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: DeleteProposalGroupInput) => {
      return gqlClient.request(DELETE_PROPOSAL_GROUP_MUTATION, { input });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useDeleteProposalGroup;
